import React from 'react';

import NoResultsIcon from 'components/common/icons/NoResultsIcon';

export interface EmptyStateProps {
  children?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ children }) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
      {children || (
        <>
          <NoResultsIcon />
          <span className="tw-mb-1 tw-mt-4">We didn&apos;t find any results.</span>
          <span className="tw-mb-1">Try a different keyword or filter.</span>
        </>
      )}
    </div>
  );
};
